import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import MainButton from "../../../../../components/main-button";
import DicotomicCheckbox from "../../../../../components/dicotomic-checkbox/dicotomic-checkbox";
import { ErrorModalContainer } from "../../../../../components/error-modal/error-modal-style";
import { TravelHireMenuHelper, StepsTravel } from "../../../../../components/travel-hire-menu";
import { TravelPaymentMethodsContainer } from "./travel-payment-methods-style";
import { images } from "../../../../../assets/images";

import { withGeneral } from "../../../../../context/mixin/with-general";
import { withPolicy } from "../../../../../context/mixin/with-policy";
import { withCoverages } from "../../../../../context/mixin/with-coverages";

import TravelServices from "../../../../../services/TravelServices";
import PayMethodServices from "../../../../../services/PayMethodServices";
import { getFormatedPayments } from "./travel-payment-methods-helpers";
import { deepGet } from "../../../../../utils/utility";
import { TravelPaymentMethodsProps } from "./travel-payment-methods-dto";
import { ProductPaymentMethod } from "../../../../../services/PayMethodServices.dto";

const TravelPaymentMethodsLayout = ({
  data,
  history,
  match,
  policy,
  setLoading,
  saveHiring,
}: TravelPaymentMethodsProps) => {
  const [payMethodList, setPayMethodList] = useState<ProductPaymentMethod[]>([]);
  const [payMethod, setPayMethod] = useState<string>(data.payment.paymentMethod || "");
  const [errorModal, setErrorModal] = useState<{ showErrorModal: boolean; errorMessage: string }>({
    showErrorModal: false,
    errorMessage: "",
  });

  useEffect(() => {
    getPayMethodList();
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  const getPayMethodList = async () => {
    const productId = deepGet(policy, "product.products_id", "") || "";
    const response = await PayMethodServices.getPayMethodByProduct({
      loader: true,
      setLoading: setLoading,
      productId,
    });
    if (response.ok) {
      setPayMethodList(response.data);
    } else if (response.error) {
      setErrorModal({ showErrorModal: true, errorMessage: response.message });
    }
  };

  const onSetPayMethod = (value: string) => {
    setPayMethod(value);
    data.payment = {
      paymentMethod: value,
    };
  };

  const onClickBack = () => {
    const product = match.params.product;
    history.push(
      TravelHireMenuHelper.getPreviousStepNavigationPath(StepsTravel.MetodosPago, product)
    );
  };

  const onClickNext = async () => {
    if (!payMethod) return;

    const prices = await TravelServices.getPrices({
      setLoading: setLoading,
      loader: true,
      data: { COTIZACION: data.idcotiza },
    });

    if (prices.ok) {
      const priceData = getFormatedPayments(prices.data);

      const newData = {
        ...data,
        priceData,
        insured: false,
        starterDay: moment().format("DD/MM/YYYY"),
      };

      policy.setTravelData(newData);
      data.priceData = newData.priceData;
      data.starterDay = moment().format("DD/MM/YYYY");
      saveHiring(false);

      history.push(
        TravelHireMenuHelper.getNextStepNavigationPath(
          StepsTravel.MetodosPago,
          match.params.product
        )
      );
    } else {
      setErrorModal({ showErrorModal: true, errorMessage: prices.message });
    }
  };

  return (
    <TravelPaymentMethodsContainer>
      <div className="data-flow-status">
        <div className="data-flow-status-title">
          <h2>MEDIOS DE PAGO</h2>
        </div>
      </div>

      <div className="content-wrapper bottomMargin20 filesSection">
        <div className="personal-data-wrapper">
          <div className="data-title">
            <h5>PAGO DEL SEGURO</h5>
          </div>

          {payMethodList.length
            ? payMethodList.map((item, index) => {
                const margin =
                  index === payMethodList.length - 1 ? "bottomMargin60" : "bottomMargin20";
                return (
                  <div className={`colSin-100 ${margin}`}>
                    <DicotomicCheckbox
                      initChecked={payMethod === item.code}
                      className="optional"
                      checkboxText={item.description}
                      onChange={() => onSetPayMethod(item.code)}
                    />
                  </div>
                );
              })
            : null}
        </div>
      </div>

      <div className="colSin-100 topMargin20 bottomMargin20">
        <div className="personal-data-buttons">
          <div className="personal-data-buttons__item">
            <MainButton
              withTab={true}
              icon={true}
              type="white"
              iconImg={images.IconArrowLeftBlue}
              text="Atrás"
              onClick={onClickBack}
            />
          </div>
          <div className="personal-data-buttons__item">
            <MainButton
              withTab={true}
              text="Siguiente"
              onClick={onClickNext}
              disabled={!payMethod}
            />
          </div>
        </div>
      </div>

      <ErrorModalContainer className={`${errorModal.showErrorModal && `active`}`}>
        <div className="recover-modal">
          <div className="server-error">
            <p>{errorModal.errorMessage}</p>
          </div>
          <div className="button-error">
            <MainButton
              text="Aceptar"
              onClick={() => setErrorModal({ showErrorModal: false, errorMessage: "" })}
            />
          </div>
        </div>
      </ErrorModalContainer>
    </TravelPaymentMethodsContainer>
  );
};

export default withPolicy(withCoverages(withGeneral(withRouter(TravelPaymentMethodsLayout))));
